import React, { useState } from 'react';
import routes from '../constants/routes.json';
import { Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-flexbox-grid';

import {
  Button,
  Card,
  Divider,
  Image,
  Modal,
  Space,
  Typography,
} from 'antd';


import 'antd/dist/antd.css';

import styles from './Home.css';

import exchanges from './exchanges.png';
import upload from './upload.png';
import results from './results.png';
import sample from './sample.png';


const { Title } = Typography;

export default function Home(): JSX.Element {
  const [visible, setVisible] = useState(false);

  return (
    <div className={styles.container} data-tid="container">
      <Title level={2}>Check your Bitcoin performance in 3 steps</Title>
      <Divider />

      {/* <Row gutter={16} className={styles.grid}> */}

      <Grid className={styles.grid} fluid>
        <Row>
          <Col xs={24} sm={12} md={12} lg={4} className={styles.antCol}>
            <Card
              bodyStyle={{
                height: '175px',
                marginTop: '-20px',
                boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.2)',
              }}
              title="1. Select Exchanges"
            >
              <img width={175} preview="false" src={exchanges} />
            </Card>
          </Col>
          <Col xs={24} sm={12} md={12} lg={4} className={styles.antCol}>
            <Card
              bodyStyle={{
                height: '155px',
                boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.2)',
              }}
              title="2. Import Transactions"
            >
              <img width={150} preview="false" src={upload} />
            </Card>
          </Col>
          <Col xs={24} sm={12} md={12} lg={4} className={styles.antCol}>
            <Card
              bodyStyle={{
                height: '155px',
                boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.2)',
              }}
              title="3. Run the Numbers"
            >
              <img width={125} preview="false" src={results} />
            </Card>
          </Col>
        </Row>
      </Grid>
      <Space>
        <Button type="primary" size="large">
          <Link to={routes.WORKFLOW}>Get Started</Link>
        </Button>

        <Button size="large" onClick={() => setVisible(true)}>
          View Sample
        </Button>
      </Space>

      <Modal
        title="Sample Results"
        centered
        visible={visible}
        onOk={() => setVisible(false)}
        onCancel={() => setVisible(false)}
        width={1100}
        footer={[
          <Button key="submit" type="primary" onClick={() => setVisible(false)}>
            Ok
          </Button>,
        ]}
      >
        <Image width={1000} src={sample} />
      </Modal>
    </div>
  );
}
